import { Moon, Sun } from 'lucide-react';
import { Outlet, Navigate, useLocation } from 'react-router';
import GlobalSpinner from '~/components/GlobalSpinner';
import ApplicationMark from '~/components/ui/ApplicationMark';
import { Toaster } from '~/components/ui/Toaster';
import { useTheme } from '~/contexts/ThemeContext';
import { useAuthStore } from '~/stores/useAuthStore';

export default function PublicLayout() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const loading = useAuthStore((state) => state.loading);
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();

  if (loading) {
    return <GlobalSpinner />;
  }

  if (isAuthenticated) {
    const redirectTo = location.state?.from?.pathname || '/dashboard';
    return <Navigate to={redirectTo} replace />;
  }

  return (
    <div className="min-h-svh w-full grid grid-cols-1 md:grid-cols-2 px-4">
      <div className="flex justify-center items-center">
        <ApplicationMark />
        <button
          className="cursor-pointer fixed top-4 right-4 p-2 rounded-md hover:bg-accent hover:text-accent-foreground transition-colors flex items-center gap-2"
          onClick={(e) => {
            e.preventDefault();
            toggleTheme();
          }}
        >
          {theme === 'light' ? (
            <Moon className="size-5" />
          ) : (
            <Sun className="size-5" />
          )}
        </button>
      </div>
      <div className="flex justify-center items-center">
        <Outlet />
        <Toaster />
      </div>
    </div>
  );
}
